export default "__VITE_ASSET__c708edae__"